import {
  formatDate,
  formatTime,
  isBlank,
  isNullOrUndefined,
} from "../../utils";
import { ReactComponent as Turnarounds } from "../../assets/turnarounds.svg";

import CrewInfo from "../CrewInfo";
import "./styles.css";
import { useNavigate } from "react-router-dom";
import { getSignedImageSrc } from "../../mediaUtils";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";

function LiveFeedPost(props) {
  const { t } = useTranslation();
  const { feedItem, timezone, onClick } = props;
  const [isLoaded, setIsLoaded] = useState(!isNullOrUndefined(feedItem.notes));
  const [hasImageError, setHasImageError] = useState(false);

  const containerRef = useRef(null);
  const imgRef = useRef(null);
  const mainRef = useRef(null);

  const navigate = useNavigate();
  const hasImage = !isNullOrUndefined(feedItem.image);
  const imageSrc = hasImage
    ? getSignedImageSrc(feedItem.image?.fullSize)
    : null;
  const hasNotes = !isNullOrUndefined(feedItem.notes);
  const notes = hasNotes ? feedItem.notes : null;

  function handleImageAdjustment() {
    const mainEl = mainRef.current;
    const imgEl = imgRef.current;
    const containerEl = containerRef.current;
    if (
      !isNullOrUndefined(imgEl) &&
      !isNullOrUndefined(containerEl) &&
      !isNullOrUndefined(mainEl)
    ) {
      const imgBounds = imgEl.getBoundingClientRect();
      const containerBounds = containerEl.getBoundingClientRect();
      if (imgBounds.width > containerBounds.width) {
        imgEl.style.width = `${containerBounds.width}px`;
        imgEl.style.height = `${
          (imgBounds.width / containerBounds.width) * containerBounds.height
        }px`;
      } else {
        // Use blurred background for smaller photos
        mainEl.style.backgroundImage = `url(${imageSrc})`;
      }
    }
    setIsLoaded(true);
  }
  function handleImageError() {
    // Image could not load, but allow render anyways
    setIsLoaded(true);
    setHasImageError(true);
  }

  if (isNullOrUndefined(feedItem)) return null;
  return (
    <div
      className={`live-feed-post${isLoaded || hasNotes ? " loaded" : ""}`}
      data-event-uuid={feedItem.uuid}
      key={feedItem}
    >
      <div>
        <div className="live-feed-post-header">
          <div>
            <div className="live-feed-post-user">
              <CrewInfo
                user={feedItem.userInfo?.user}
                details={feedItem.operationDepartment?.name}
              />
            </div>
          </div>
        </div>
        <div className="live-feed-post-body">
          {hasImage && (
            <div className="live-feed-post-image" ref={mainRef}>
              <div
                className="live-feed-post-image-container"
                ref={containerRef}
              >
                {!hasImageError && (
                  <img
                    src={imageSrc}
                    alt={feedItem.eventType?.name}
                    width="100%"
                    ref={imgRef}
                    onLoad={handleImageAdjustment}
                    onError={handleImageError}
                    onClick={() => {
                      onClick(feedItem);
                    }}
                  />
                )}
                {hasImageError && (
                  <div
                    data-imageurl={imageSrc}
                    className="empty-state de-emphasize"
                  >
                    {t("image_could_not_be_loaded")}
                  </div>
                )}
              </div>
            </div>
          )}
          {hasNotes && (
            <div className="live-feed-post-notes">
              <div>{notes}</div>
            </div>
          )}
        </div>
        <div className="live-feed-post-footer">
          <div>
            <div className="live-feed-post-event-type">
              <div className="live-feed-post-stack">
                <div>{feedItem.eventType?.name}</div>
                <div>{feedItem.operationType?.name}</div>
              </div>
            </div>
            <div className="live-feed-post-divider"></div>
            <div>
              <div
                className="live-feed-post-turnaround"
                onClick={() => {
                  navigate(`/turnarounds/${feedItem.turnaroundInfo?.uuid}`);
                }}
              >
                <div>
                  <div>
                    <Turnarounds />
                  </div>
                  <div className="live-feed-post-stack">
                    <div>{feedItem.turnaroundInfo?.combinedFlightName}</div>
                    <div>{`${feedItem.turnaroundInfo?.originAirport}${
                      !isBlank(feedItem.turnaroundInfo?.destinationAirport)
                        ? ` - ${feedItem.turnaroundInfo?.destinationAirport}`
                        : ""
                    }`}</div>
                  </div>
                </div>
              </div>
            </div>
            <div></div>
            <div>
              {!isNullOrUndefined(feedItem.submittedAt) && (
                <div className="live-feed-post-timestamp">{`${formatDate(
                  feedItem.submittedAt,
                  timezone
                )} ${formatTime(feedItem.submittedAt, timezone)}`}</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveFeedPost;
